// All APIs related to User authentication, profile, etc.
import { APP_ALERT_SERVER_URL } from "@/environment";
import { IUser } from "@/types";

import * as http from "./http";

export const APIUrl = APP_ALERT_SERVER_URL + "/py/";

export const setPassword = (token: string, password: string) => {
  const api = APIUrl + "auth/set_password";
  return http
    .post(api, { body: { token, new: password }, credentials: "include" })
    .then((response) => {
      return response;
    });
};

export const verifyPasswordStrength = (password) => {
  const api = APIUrl + "auth/strength_check";
  return http
    .post(api, { body: { password }, credentials: "include" })
    .then((response) => {
      return response;
    });
};

export const resetUser = (data) => {
  const api = APIUrl + "auth/reset";
  return http.post(api, { body: data }).then((response) => {
    return response;
  });
};

export const getSSODetails = (organizationSlug: string) => {
  const api = APIUrl + "auth/org/" + organizationSlug;
  return http.get(api).then((response) => {
    return response;
  });
};

export const ssoStart = (connectionID: string) => {
  const api = APIUrl + "auth/sso_start/" + connectionID;
  return http.get(api).then((response) => {
    return response;
  });
};

export const userDetails = (): Promise<IUser> => {
  const api = APIUrl + "user/me";
  return http
    .get(api, { credentials: "include" })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const ChangePassword = (data) => {
  const api = APIUrl + "auth/password_reset";
  return http
    .post(api, { body: data, credentials: "include" })
    .then((response) => {
      return response;
    });
};

export const ResetPassword = (data) => {
  const api = APIUrl + "auth/email_reset_flow_reset";
  return http
    .post(api, { body: data, credentials: "include" })
    .then((response) => {
      return response;
    });
};
